import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

export function getPaginatorIntl(translate: TranslateService): MatPaginatorIntl {
  const paginatorIntl = new MatPaginatorIntl();

  const setLabels = () => {
    paginatorIntl.itemsPerPageLabel = translate.instant('paginator.itemsPerPage');
    paginatorIntl.nextPageLabel = translate.instant('paginator.nextPage');
    paginatorIntl.previousPageLabel = translate.instant('paginator.previousPage');
    paginatorIntl.firstPageLabel = translate.instant('paginator.firstPage');
    paginatorIntl.lastPageLabel = translate.instant('paginator.lastPage');
    paginatorIntl.changes.next();
  };

  setLabels();

  translate.onLangChange.subscribe(() => setLabels());

  return paginatorIntl;
}
